<template>
  <div>
    <div class="mc-hero">
      <div class="mc-hero-icon">
        <svg
          width="34"
          height="34"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h1 class="mc-h1">Windscreen claim submitted</h1>
      <p v-if="fitter" class="mc-lede">
        We've assigned <b>{{ fitter.name }}</b> as your approved fitter.
        They'll call <b>{{ phone || 'your number' }}</b> to agree the
        exact arrival time.
      </p>
      <p v-else class="mc-lede">
        We're confirming your windscreen benefit and assigning an approved
        fitter. They'll call <b>{{ phone || 'your number' }}</b> to agree the
        exact arrival time.
      </p>
    </div>

    <div v-if="fitter" class="mc-card">
      <div class="mc-cardhead"><b>Assigned Fitter</b></div>
      <div class="mc-kv">
        <span>Fitter</span><b>{{ fitter.name }}</b>
      </div>
      <div v-if="fitter.phoneNumber" class="mc-kv">
        <span>Fitter Phone</span><b><a :href="`tel:${fitter.phoneNumber}`" class="mc-help-number">{{ fitter.phoneNumber }}</a></b>
      </div>
      <div v-if="fitter.email" class="mc-kv">
        <span>Fitter Email</span><b>{{ fitter.email }}</b>
      </div>
    </div>

    <div class="mc-card">
      <div class="mc-cardhead"><b>What you told us</b></div>
      <div class="mc-kv">
        <span>Vehicle</span><b>{{ reg }}</b>
      </div>
      <div class="mc-kv">
        <span>Fitting at</span><b>{{ locationName }}</b>
      </div>
      <div class="mc-kv">
        <span>Preferred time</span><b>{{ whenLabel }}</b>
      </div>
    </div>

    <div class="mc-card">
      <div class="mc-cardhead"><b>Something changed?</b></div>
      <div class="mc-help-copy">
        If the car moves, the time no longer works, or you haven't heard from a
        fitter, call APA claims on
        <a class="mc-help-number" href="tel:+254709912000">0709 912 000</a>.
        Quote your registration &mdash; windscreen claims don't issue a separate
        reference.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WindscreenDoneStep',
  props: {
    reg: { type: String, default: '' },
    phone: { type: String, default: '' },
    locationName: { type: String, default: '' },
    whenLabel: { type: String, default: '' },
    fitter: { type: Object, default: null },
  },
}
</script>

<style scoped>
.mc-hero {
  text-align: center;
  padding: 26px 10px 18px;
}

.mc-hero-icon {
  width: 76px;
  height: 76px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #e3f4ea;
  display: grid;
  place-items: center;
  color: #166534;
}

.mc-h1 {
  font-size: 24px;
  line-height: 1.22;
  font-weight: 700;
  margin: 0 0 8px;
  color: #14142b;
  letter-spacing: -0.35px;
}

.mc-lede {
  font-size: 14.5px;
  color: #6e7191;
  margin: 0;
}

.mc-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
}

.mc-cardhead {
  margin-bottom: 10px;
}

.mc-cardhead b {
  font-size: 14.5px;
  font-weight: 700;
  color: #14142b;
}

.mc-kv {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 8px 0;
  border-top: 1px solid #f0f0f4;
  font-size: 13.5px;
}

.mc-kv:first-of-type {
  border-top: 0;
}

.mc-kv span {
  color: #6e7191;
  flex: 0 0 auto;
}

.mc-kv b {
  color: #14142b;
  font-weight: 600;
  text-align: right;
  min-width: 0;
}

.mc-help-copy {
  font-size: 13.5px;
  color: #6e7191;
  line-height: 1.6;
}

.mc-help-number {
  color: #0052b3;
  font-weight: 700;
  white-space: nowrap;
}
</style>
